import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './HomePage.module.scss';

import LogoCdh from '../../assets/imgs/logo-cdh.png';
import google_store_btn from '../../assets/imgs/btn_google_play_new.png';
import apple_store_btn from '../../assets/imgs/btn_apple_store_new.png';
import qr_cdh from '../../assets/imgs/qr-with-cdh-img.svg';
import { SocialMediaLinks } from '../SocialMediaLinks/SocialMediaLinks';

const cdhGpLink = "https://go.onelink.me/bUzl/9c836b67";
const cdhAppStoreLink = "https://go.onelink.me/VHLW/e01c1c3f";

const HomePage = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.homepage}>
            <div className={styles.home_contents}>
                <img src={LogoCdh} alt="cdh-logo" className={styles.cdh_logo} />
                <div className={styles.f2p_f2e}>
                    <span>{t('HERO_TANGLINE_1A').toUpperCase()}</span>
                    <div className={styles.diamond_shape}></div>
                    <span>{t('HERO_TANGLINE_1B').toUpperCase()}</span>    
                </div>
                <div className={styles.description_text}>{t('HERO_TANGLINE_2')}</div>
                <div className={styles.app_and_socials}>
                    <div className={styles.store_btns}>
                        <a href={cdhAppStoreLink} target="_blank" rel="noopener noreferrer">
                            <img src={apple_store_btn} alt="apple-app-store" className={styles.app_store_btn} />
                        </a>
                        <a href={cdhGpLink} target="_blank" rel="noopener noreferrer">
                            <img src={google_store_btn} alt="google-app-store" className={styles.app_store_btn} />
                        </a>
                        <img src={qr_cdh} alt="app-store-qr" className={styles.app_qr} />
                    </div>

                    <div className={styles.mobile_social_links_container}>
                        <SocialMediaLinks />
                    </div>
                </div>
            </div>
        </div>
    );
};

export { HomePage };
